module.exports = __webpack_public_path__ + "img/CUADRO-ROJO-02.ec726b47.png";